import React, { useContext, useState } from "react";
import im from "../im/img.png";
import at from "../im/attach.png";
import { AuthContext } from "../context/AuthContext";
import {auth,storage} from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { ChatContext } from "../context/ChatContext";
import { doc, Timestamp, updateDoc,arrayUnion, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import {v4 as uuid} from "uuid";


const Input=()=>{
    

    const [text,setText]=useState("");
    const [img,setImg]=useState(null);
    const {currentUser}=useContext(AuthContext);
    const {data}=useContext(ChatContext);
    const handleSend=async()=>{
        if(img){
            const storageRef = ref(storage, uuid());

            const uploadTask = uploadBytesResumable(storageRef, img);
            uploadTask.on(
                (error) => {
                  console.log(error);
                }, 
                () => {
                  getDownloadURL(uploadTask.snapshot.ref).then(async(downloadURL) => {
                    await updateDoc(doc(db,"chats",data.chatId),{
                        messages:arrayUnion({
                            id:uuid(),
                            text,
                            senderId:currentUser.uid,
                            date:Timestamp.now(),
                            img:downloadURL,
                        }),
                    });
                 
              });
                }
              );
        }else{
            await updateDoc(doc(db,"chats",data.chatId),{
                messages:arrayUnion({
                    id:uuid(),
                    text,
                    senderId:currentUser.uid,
                    date:Timestamp.now(),
                }),
            });
        }
        await updateDoc(doc(db,"userchats",currentUser.uid),{
            [data.chatId+".lastMessage"]:{
                text,
            },
            [data.chatId+".data"]:serverTimestamp(),
        });
        await updateDoc(doc(db,"userchats",data.user.uid),{
            [data.chatId+".lastMessage"]:{
                text,
            },
            [data.chatId+".data"]:serverTimestamp(),
        });

        setText("");
        setImg(null);
    };


    return(
        <div className="Input">
            <input type="text" placeholder="Type Something...."  onChange={e=>setText(e.target.value)} value={text}/>
            <div className="Send">
                <img src={at} alt="" />
                <input type="file" style={{display:'none'}} id="file" onChange={e=>{setImg(e.target.files[0])}}/>
                <label htmlFor="file">
                    <img src={im} alt="" />
                </label>
                <button onClick={handleSend}>Send</button>

            </div>
        </div>
    )
}

export default Input